import React, { useState, useEffect } from 'react'

import { 
    Auth,
    API 
} from 'aws-amplify'

// Form

import { 
    useForm
} from "react-hook-form"

import {
    ErrorText
} from '../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    SectionHeader, 
    SettingRowDiv,
    FullSettingDiv,
    SettingHeader,
    InputField,
    SaveButton,
    CancelButton
} from '../../Styles/Components/SettingsSectionStyles'

import {
    HeaderInfoDiv,
    SubscriptionInfoDiv,
    SubscriptionActionDiv,
    FormDiv,
    HeaderInfo,
    SubscriptionInfo,
    SubscriptionAction,
    SubscriptionTypeContainerDiv,
    SubscriptionTypeBoxDiv,
    SubscriptionTypeBoxContentsDiv,
    SubscriptionTypeTierDiv,
    SubscriptionTypeTierText,
    SubscriptionPerkList,
    SubscriptionPerkListItem,
    SubscriptionDetailsSection,
    SubscriptionDetailsDiv,
    SubscriptionDetailsType,
    SubscriptionDetailsValue
} from '../../Styles/Components/SubscriptionSettingsSectionStyles'

import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js'

import { 
    useSelector,
    useDispatch
} from 'react-redux'

import '../../Styles/CSS/stripe.css'

import * as SubscriptonSettingsEnums from '../../Constants/SubscriptionSettingsEnums'

import {
    showAlert
} from '../../Redux/Slices/SettingsSlice'

import {
    capitalizeFirstLetter,
    formatErrorMessage
} from '../../Utilities/StringTools'

import {
    setUser
} from '../../Redux/Slices/UserSlice'

function SubscriptionSettingsSection(props){
    const user = useSelector(state => state.user.user)
    const userGroup = user.user_group
    const dispatch = useDispatch()

    const subscribed = (userGroup !== 'none')
    const subscription = getSubscriptionTier(userGroup)

    const defaultState = {
        page: !subscribed ? SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_SELECTION : SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO,
        action: !subscribed ? SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.SUBSCRIBING : SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.VIEWING
    }

    const [subscriptionSettingsState,setSubscriptionSettingsState] = useState(defaultState)

    function getSubscriptionTier(userGroup){
        switch(userGroup){
            case 'base':
                return 'Base Tier'
            case 'super':
                return 'Super Tier'
            default:
                return capitalizeFirstLetter(userGroup)
        }
    }

    useEffect(() => {
        if(subscriptionSettingsState.page === SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO){
            Auth.currentAuthenticatedUser().then(user => dispatch(setUser({user: user}))).catch()
        }
    }, [subscriptionSettingsState.page])

    let pricingData = require('../../Data/pricing_data.json')
    let pricingDataMap = createPricingDataMap(pricingData.pricing_type_data)

    var view = (
        <>
        </>
    )

    function createPricingDataMap(data){
        var dataMap = {}
        data.forEach((subscription) => {
            if(subscription.tier !== 'Free Trial'){
                dataMap[subscription.tier] = {cost: subscription.cost, perks: subscription.perks, stripe: subscription.stripe}
            }
        })
        return dataMap
    }

    switch(subscriptionSettingsState.page){
        case SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO:
            view = <SubscriptionInfoView subscribed={subscribed} currentSubscription={subscription} subscriptionSettingsState={subscriptionSettingsState} setSubscriptionSettingsState={setSubscriptionSettingsState} pricingData={pricingDataMap} />
            break
        case SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_PAYMENT:
            view = <SubscriptionPaymentView subscribed={subscribed} currentSubscription={subscription} subscriptionSettingsState={subscriptionSettingsState} setSubscriptionSettingsState={setSubscriptionSettingsState} pricingData={pricingDataMap} />
            break
        case SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_SELECTION:
            view = <SubscriptionSelectionView subscribed={subscribed} currentSubscription={subscription} subscriptionSettingsState={subscriptionSettingsState} setSubscriptionSettingsState={setSubscriptionSettingsState} pricingData={pricingDataMap} />
            break
        default:
            break
    }

    return (
        <SectionDiv id = 'subscription-settings-section'>
            {view}
        </SectionDiv>
    )
}

function SubscriptionPaymentView(props){
    const subscriptionSettingsState = props.subscriptionSettingsState
    const setSubscriptionSettingsState = props.setSubscriptionSettingsState
    const pricingData = props.pricingData
    const currentSubscription = props.currentSubscription

    const action = subscriptionSettingsState.action

    const subscriptionType = ('updated_subscription' in subscriptionSettingsState) ? subscriptionSettingsState.updated_subscription : currentSubscription
    const subscriptionCost = pricingData[subscriptionType].cost

    const clientSecret = ('client_secret' in subscriptionSettingsState) ? subscriptionSettingsState.client_secret : ''
    
    const [cardErrorMessage,setCardErrorMessage] = useState('')

    var view = (
        <>
        </>
    )

    const cardOptions = {
        iconStyle: "solid",
        style: {
            base: {
                iconColor: '#000',
                color: '#000',
                fontSize: '16px',
                fontSmoothing: 'antialiased',
                ':-webkit-autofill': {
                    color: '#fce883',
                },
            },
            invalid: {
                iconColor: '#FFC7EE',
                color: '#FFC7EE',
            },
        },
    }

    const stripe = useStripe()
    const elements = useElements()

    const { register, handleSubmit, errors, reset } = useForm({
        validateCriteriaMode: "all",
        mode: "onChange",
    })

    async function subscribe(data,event){
        event.preventDefault()

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return
        }

        if (cardErrorMessage !== ''){
            // There as an error with the card data
            return
        }

        const name = data.name
        const cardElement = elements.getElement(CardElement)

        stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: cardElement,
                billing_details: {
                    name: name,
                },
            }
        })
        .then((result) => {
            if(result.error) {
                setCardErrorMessage(formatErrorMessage(result.error.message))
            } else {
                setSubscriptionSettingsState({
                    page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO,
                    action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.VIEWING
                })
            }
        });
    }

    function updatePayment(data){
        console.log(data)
        setSubscriptionSettingsState({
            page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO,
            action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.VIEWING
        })
    }

    function cancel(){
        reset()
        if(action === SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.CHANGING){
            setSubscriptionSettingsState({
                page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO,
                action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.VIEWING
            })
        }
        else{
            setSubscriptionSettingsState({
                page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_SELECTION,
                action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.SUBSCRIBING
            })
        }
    }

    function cardOnChange(event){
        if((typeof event.error)!== 'undefined'){
            setCardErrorMessage(formatErrorMessage(event.error.message))
        }
        else{
            if(cardErrorMessage !== ''){
                setCardErrorMessage('')
            }
        }
    }

    switch(action){
        case SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.SUBSCRIBING:
            view = (
                <>
                    <HeaderDiv>
                        <SectionHeader>Subscription Payment</SectionHeader>
                    </HeaderDiv>
                    <HeaderInfoDiv>
                        <HeaderInfo>Enter your card details to subscribe.</HeaderInfo>
                    </HeaderInfoDiv>
                    <SubscriptionInfoDiv>
                        <SubscriptionInfo>&nbsp;Cost:&nbsp;<strong>{subscriptionCost}</strong></SubscriptionInfo>
                        <SubscriptionInfo>&nbsp;Subscribing to&nbsp;<strong>{subscriptionType}</strong></SubscriptionInfo>
                    </SubscriptionInfoDiv>
                    <FormDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Full Name:</SettingHeader>
                                <InputField 
                                    type="text" name="name" placeholder='First and Last name'
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 70,
                                                message: 'exceeds 70 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                />
                                {errors['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['name']['message']}</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Card Details:</SettingHeader>
                                <CardElement options={cardOptions} className='card' onChange={cardOnChange} />
                                {cardErrorMessage !== '' && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">*{cardErrorMessage}</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv style={{'marginTop': '1rem'}}>
                                <CancelButton onClick={cancel}>Select Tier</CancelButton>
                                <SaveButton onClick={handleSubmit(subscribe)} disabled={!stripe}>Subscribe</SaveButton>
                            </FullSettingDiv>
                        </SettingRowDiv>
                    </FormDiv>
                </>
            )
            break
        case SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.CHANGING:
            view = (
                <>
                    <HeaderDiv>
                        <SectionHeader>Update Payment</SectionHeader>
                    </HeaderDiv>
                    <HeaderInfoDiv>
                        <HeaderInfo>Enter your card details to update your payment.</HeaderInfo>
                    </HeaderInfoDiv>
                    <SubscriptionInfoDiv>
                        <SubscriptionInfo>&nbsp;Subscribed to&nbsp;<strong>{subscriptionType}</strong></SubscriptionInfo>
                    </SubscriptionInfoDiv>
                    <FormDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Full Name:</SettingHeader>
                                <InputField 
                                    type="text" name="name" placeholder='First and Last name'
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 70,
                                                message: 'exceeds 70 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                />
                                {errors['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['name']['message']}</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Card Details:</SettingHeader>
                                <CardElement options={cardOptions} className='card' onChange={cardOnChange} />
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv style={{'marginTop': '1rem'}}>
                                <CancelButton onClick={cancel}>Cancel</CancelButton>
                                <SaveButton onClick={handleSubmit(updatePayment)} disabled={!stripe}>Save</SaveButton>
                            </FullSettingDiv>
                        </SettingRowDiv>
                    </FormDiv>
                </>
            )
            break
        default:
            break
    }

    return (
        <>
            {view}
        </>
    )
}

function SubscriptionSelectionView(props){
    const subscribed = props.subscribed
    
    const subscriptionSettingsState = props.subscriptionSettingsState
    const setSubscriptionSettingsState = props.setSubscriptionSettingsState

    const pricingData = props.pricingData
    const currentSubscription = props.currentSubscription

    const action = subscriptionSettingsState.action
    const currentSubscriptionCost = currentSubscription !== 'None' ? pricingData[currentSubscription].cost : 'None'

    const [selectedSubscription,setSelectedSubscription] = useState(currentSubscription)
    const [showError,setShowError] = useState(false)

    const user = useSelector(state => state.user.user)

    const dispatch = useDispatch()

    function cancel(){
        if(subscribed){
            setSubscriptionSettingsState({
                page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_INFO,
                action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.VIEWING
            })
        }
        else{
            dispatch(showAlert({alertType: 'exitSubscribing'}))
        }
    }

    async function select(){
        setShowError(selectedSubscription === 'None')
        if(selectedSubscription !== 'None'){
            await API.post('quickfillerapi','/create-subscription',{
                body: {
                    customerId: user.stripe_id,
                    priceId: pricingData[selectedSubscription].stripe.price_id
                }
            })
            .then(response => {
                setSubscriptionSettingsState({
                    page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_PAYMENT,
                    action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.SUBSCRIBING,
                    updated_subscription: selectedSubscription,
                    client_secret: response.clientSecret
                })
            })
            .catch(error => {
                console.log(error)
            })
        }
    }

    return (
        <>
            <HeaderDiv>
                <SectionHeader>Subscription Options</SectionHeader>
            </HeaderDiv>
            <HeaderInfoDiv>
                <HeaderInfo>Select a subscription tier.</HeaderInfo>
            </HeaderInfoDiv>
            {action === SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.CHANGING && 
                <SubscriptionInfoDiv>
                    <SubscriptionInfo>&nbsp;Current Payment:&nbsp;<strong>{currentSubscriptionCost}</strong></SubscriptionInfo>
                    <SubscriptionInfo>&nbsp;Current Subscription:&nbsp;<strong>{currentSubscription}</strong></SubscriptionInfo>
                </SubscriptionInfoDiv>
            }
            <SubscriptionTypeContainerDiv>
                {Object.keys(pricingData).map(key => 
                    <SubscriptionTypeBox onClick={()=>{setSelectedSubscription(key); setShowError(false)}} selected={(key === selectedSubscription)} subscriptionTier={key} subscriptionCost={pricingData[key].cost} subscriptionPerks={pricingData[key].perks} key={key} />
                )}
            </SubscriptionTypeContainerDiv>
            {showError && <ErrorText p={0} ml={0} mr={0} mb="2rem">*select a subscription tier</ErrorText>}
            <SettingRowDiv>
                <FullSettingDiv>
                    <CancelButton onClick={cancel}>Cancel</CancelButton>
                    <SaveButton onClick={select}>Select Tier</SaveButton>
                </FullSettingDiv>
            </SettingRowDiv>
        </>
    )
}

function SubscriptionTypeBox(props){
    let subscriptionTier = props.subscriptionTier
    let subscriptionCost = props.subscriptionCost
    let subscriptionPerks = props.subscriptionPerks

    let onClick = props.onClick
    let selected = props.selected

    var style = {}

    if(selected){
        style = {'backgroundColor': '#4267B2', 'color': 'white'}
    }

    return (
        <SubscriptionTypeBoxDiv onClick={onClick} style={style}>
            <SubscriptionTypeBoxContentsDiv>
                <SubscriptionTypeTierDiv>
                    <SubscriptionTypeTierText>{subscriptionTier}&nbsp;|&nbsp;{subscriptionCost}</SubscriptionTypeTierText>
                </SubscriptionTypeTierDiv>
                <SubscriptionPerkList>
                    {subscriptionPerks.map(item => (
                        <SubscriptionPerkListItem key={item}>&nbsp;{item}</SubscriptionPerkListItem>
                    ))}
                </SubscriptionPerkList>
            </SubscriptionTypeBoxContentsDiv>
        </SubscriptionTypeBoxDiv>
    )
}

function SubscriptionInfoView(props){
    const setSubscriptionSettingsState = props.setSubscriptionSettingsState
    const currentSubscription = props.currentSubscription

    const cardDetails = 'None'

    function changePlan(){
        setSubscriptionSettingsState({
            page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_SELECTION,
            action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.CHANGING
        })
    }

    function cancelSubscription(){
        console.log('Cancel Subscription')
    }

    function changePayment(){
        setSubscriptionSettingsState({
            page: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_PAGES.SUBSCRIPTION_PAYMENT,
            action: SubscriptonSettingsEnums.SUBSCRIPTION_SETTINGS_ACTIONS.CHANGING
        })
    }

    return (
        <>
            <HeaderDiv>
                <SectionHeader>Subscription Details</SectionHeader>
            </HeaderDiv>
            <HeaderInfoDiv>
                <HeaderInfo style={{'fontWeight': 'bold'}}>Account</HeaderInfo>
            </HeaderInfoDiv>
            <SubscriptionDetailsSection>
                <SubscriptionDetailsDiv>
                    <SubscriptionDetailsType>Current Plan</SubscriptionDetailsType>
                    <SubscriptionDetailsValue>{currentSubscription}</SubscriptionDetailsValue>
                </SubscriptionDetailsDiv>
                <SubscriptionDetailsDiv>
                    <SubscriptionDetailsType>Credit Card</SubscriptionDetailsType>
                    <SubscriptionDetailsValue>{cardDetails}</SubscriptionDetailsValue>
                </SubscriptionDetailsDiv>
            </SubscriptionDetailsSection>
            {currentSubscription !== 'Super Tier' && <SubscriptionActionDiv>
                <SubscriptionAction onClick={changePlan}>Change Plan&nbsp;</SubscriptionAction>
                <SubscriptionAction onClick={changePayment}>Change Payment&nbsp;</SubscriptionAction>
                <SubscriptionAction style={{'color': 'red'}} onClick={cancelSubscription}>Cancel Subscription&nbsp;</SubscriptionAction>
            </SubscriptionActionDiv>}
        </>
    )
}

export default SubscriptionSettingsSection